var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-office-create"},[_c('AHeading',{staticClass:"admin-office-create__heading",attrs:{"lebel":1}},[_vm._v("施設登録")]),_c('OOfficeCreateCsv')],1)}
var staticRenderFns = []

export { render, staticRenderFns }